import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import styles from './Routes.scss'
import {browserHistory} from 'react-router'
import cardStyles from 'common/SearchableCard/SearchableCard.scss'
import {SearchableCardMulti, SearchableCardInput, SearchableCardLocationInput} from 'common/SearchableCardMulti'
import {Card} from 'common/styleguide/Card'
import {Loadable} from 'common/Loadable'
import {apiv3} from 'lib/apiv3'
import _ from 'lodash'
import {findAsYouType} from 'lib/findAsYouType'
import {EmptyRoutes} from './EmptyRoutes'
import {PopoverFilter, FilterButton} from 'common/PopoverFilter'
import popoverFilterStyles from 'common/PopoverFilter/PopoverFilter.scss'
import {OrderedMap, Map, Set} from 'immutable'
import {withMetricUnits} from 'common/units/MetricUnitsContext'
import * as Filters from '../shared/filters'
import {Chip} from 'common/styleguide/Chip'
import {IntroWidget} from 'common/IntroWidget'
import {TRouteAccordian, TRouteListItemExpandable} from '../shared/TRouteAccordian'
import {RouteCondensedStats} from './RouteCondensedStats'
import {LoadableExpandedRoutePreview} from './ExpandedRoutePreview'
import {currentUserHasPrivilege} from 'lib/utils'
import * as userActions from 'lib/api/currentUser'
import * as favoritesActions from 'lib/api/favorites'
import * as routesActions from 'lib/api/routes'
import {Route} from 'data/records'
import {routeSelectors as routeResourceSelectors} from 'data/resources/routes'
import {collectionActions} from 'data/resources/collections'
import {collectionItemActions} from 'data/resources/collectionItems'
import {CTA} from 'common/styleguide/CTA'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import {PopoverMenuItem, PopoverMenuHeading} from 'common/styleguide/PopoverMenu'
import {RadioGroup} from 'common/styleguide/RadioGroup'
import {Icon} from 'common/Icon'
import popoverMenuStyles from 'common/styleguide/PopoverMenu/PopoverMenu.scss'
import {DEFAULT_OFFSET, DEFAULT_PER_PAGE, MAX_PER_PAGE} from 'lib/loadAllPages'
import {ColWrap, MainCol} from 'common/layouts/SideNavLayout/TwoCol'
import Helmet from 'react-helmet'
import {IeNudgeBar} from 'common/IeNudgeBar'
import {withSelect} from 'common/WithSelectable'
import {RowCheckbox} from '../shared/RowCheckbox'
import {MobileCollapse} from 'common/layouts/SideNavLayout/SideNavContexts'
import {DeleteTRoutes, DELETE_TROUTES_DIALOG} from 'common/dialogs/DeleteTRoute'
import {ArchiveRoutes, UnarchiveRoutes, ARCHIVE_ROUTES_DIALOG, UNARCHIVE_ROUTES_DIALOG} from 'common/dialogs/ArchiveRoute'
import {Checkbox} from 'common/styleguide/Checkbox'
import cx from 'classnames'
import {spoofV3ResourceExtras} from 'data/helpers/spoofActionCreator'

const sortBySearchOpts = {
  created: 'created',
  updated: 'updated',
  name: 'name',
  distance: 'length',
  eleGain: 'elevation'
}

const sortByMenuOpts = OrderedMap({
  created: 'Created On',
  updated: 'Updated On',
  name: 'Name',
  distance: 'Distance',
  eleGain: 'Elevation Gain'
})

const sortDirMenuOpts = OrderedMap({
  'ASC': 'Ascending',
  'DESC': 'Descending'
})

const imperialRadiusMenuOpts = OrderedMap({
  '1': '1 mile',
  '5': '5 miles',
  '10': '10 miles',
  '25': '25 miles',
  '50': '50 miles',
  '100': '100 miles',
  '250': '250 miles'
})

const metricRadiusMenuOpts = OrderedMap({
  '5': '5 kilometers',
  '10': '10 kilometers',
  '25': '25 kilometers',
  '50': '50 kilometers',
  '100': '100 kilometers',
  '250': '250 kilometers',
  '500': '500 kilometers'
})

const privacyOptions = OrderedMap({
  public: 'Public',
  friendsOnly: 'Friends only',
  private: 'Private'
})

const startPageOptions = {
  offset: DEFAULT_OFFSET,
  limit: DEFAULT_PER_PAGE,
  loadMoreClicked: false
}

export class _Routes extends React.PureComponent {
  constructor (props) {
    super(props)
    const {loadableResources: initialResults} = props

    this.state = Object.assign({
      searchParams: {
        searchKeywords: '',
        locationKeywords: '',
        sortBy: 'created',
        sortDir: 'DESC',
        radius: '10',
        filters: Map()
      },
      initialResults,
      search: initialResults,
      searchPending: false,
      selectAllChecked: false,
      dialog: null
    }, startPageOptions)
    this._findAsYouType = findAsYouType({
      searchFn: this.executeSearch,
      onResults: this.onResults,
      throttle: 0
    })
    this._debouncedFindAsYouType = _.debounce(this._findAsYouType, 350)
  }

  componentDidMount () {
    const historyState = browserHistory.getCurrentLocation().state
    if (historyState) {
      const searchParams = {...historyState}
      if (searchParams.filters.privacy) {
        searchParams.filters.privacy = Set(searchParams.filters.privacy)
      }
      searchParams.filters = Map(searchParams.filters)
      this.newSearch(searchParams, this._findAsYouType)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const {search, selectAllChecked, searchPending} = this.state
    const {results} = search

    const aSearchJustCompleted = prevState.searchPending && !searchPending
    if (!prevState.selectAllChecked && selectAllChecked && !aSearchJustCompleted) {
      this.props.selectItems(results.map((t) => t.id))
    }
    if (prevState.selectAllChecked && !selectAllChecked && !aSearchJustCompleted) {
      this.props.clearSelection()
    }
  }

  newSearch = (newSearchParams, callback) => {
    const searchParams = {...this.state.searchParams, ...newSearchParams}
    this.setState(Object.assign({}, startPageOptions, {searchParams}, {searchPending: true, selectAllChecked: false}),
      () => {
        this.props.clearSelection()
        callback()
      }
    )
  }

  onSearchKeywordChange = (e) => {
    const searchKeywords = e.target.value
    this.newSearch({searchKeywords}, this._debouncedFindAsYouType)
  }

  onLocationKeywordChange = (e) => {
    const locationKeywords = e.target.value
    this.newSearch({locationKeywords}, this._debouncedFindAsYouType)
  }

  onSortByChange = (e) => {
    this.newSearch({sortBy: e}, this._findAsYouType)
  }

  onHasCuesheetClicked = (e) => {
    e.stopPropagation()
    const {filters} = this.state.searchParams

    if (filters.get('hasCuesheet')) {
      this.clearFilter('hasCuesheet')
    } else {
      this.setFilter('hasCuesheet', true)
    }
  }

  onArchivedClicked = (e) => {
    e.stopPropagation()
    const {filters} = this.state.searchParams

    if (filters.get('archived')) {
      this.clearFilter('archived')
    } else {
      this.setFilter('archived', true)
    }
  }

  onSortDirChange = (sortDir) => {
    this.newSearch({sortDir}, this._findAsYouType)
  }

  toggleSelectAll = () => {
    this.setState((state) => ({selectAllChecked: !state.selectAllChecked}))
  }

  onRadiusChange = (radius) => (this.newSearch({radius}, this._findAsYouType))

  executeSearch = (extraCriteria = {}) => {
    const {currentUser} = this.props
    const {
      searchParams: {
        searchKeywords,
        locationKeywords,
        sortBy,
        sortDir,
        radius,
        filters
      },
      offset,
      limit
    } = this.state

    // note - the search endpoint does unit conversion automatically, on
    // the backend, based off the user's metric_units preference. There
    // isn't any way to override this, we just have to make sure that
    // we display 'km' and 'meter' labels for users that have metricUnits=t
    // and imperial labels for users that don't, and then hand off the
    // user input untouched to the search function
    return apiv3.routes.search({
      keywords: searchKeywords,
      offset: offset,
      limit: limit,
      userId: currentUser.id,
      sortBy: `${sortBySearchOpts[sortBy]} ${sortDir}`,
      startLocation: locationKeywords,
      radius: radius,
      ...filters.toJS(),
      ...extraCriteria
    })
  }

  isDefaultSearch = () => {
    const {searchParams} = this.state
    return (!searchParams.searchKeywords) &&
    (!searchParams.locationKeywords) &&
    (searchParams.filters.size === 0) &&
    (searchParams.sortBy === 'created') &&
    (searchParams.sortDir === 'DESC') &&
    (searchParams.radius === '10') &&
    (this.state.offset === startPageOptions['offset']) &&
    (this.state.limit === startPageOptions['limit'])
  }

  onResults = (nextSearch) => {
    const {spoofRoutes} = this.props
    const {searchParams} = this.state

    spoofRoutes(nextSearch.rawResults)
    browserHistory.replace({...browserHistory.getCurrentLocation(), state: {...searchParams, filters: searchParams.filters.toJS()}})

    if (nextSearch.params.mergeResults) {
      this.setState((prevState) => {
        const combinedResults = _.concat(prevState.search.results, nextSearch.results)
        return {
          search: Object.assign({}, prevState.search, {results: combinedResults}),
          searchPending: false
        }
      })
    } else {
      this.setState({
        search: nextSearch,
        searchPending: false
      })
    }
  }

  setFilter = (filterKey, filterValue) => {
    this.newSearch({
      filters: this.state.searchParams.filters.set(filterKey, filterValue)
    }, this._findAsYouType)
  }

  clearFilter = (filterKey) => {
    this.newSearch({
      filters: this.state.searchParams.filters.remove(filterKey)
    }, this._findAsYouType)
  }

  // like clearFilter, but takes an array
  clearFilters = (filterKeys) => {
    const {filters} = this.state.searchParams
    const newFilters = filters

    this.newSearch({
      filters: newFilters.withMutations(nf => filterKeys.forEach(f => nf.remove(f)))
    }, this._findAsYouType)
  }

  getSelectedItems = () => {
    const {selectedItems} = this.props
    const {search} = this.state
    const {results} = search

    // Just to be double-sure that only items currently displayed can be selected
    return results.filter((t) => selectedItems.has(t.id))
  }

  setPrivacy = (privacy) => {
    const {clearSelection, batchSetVisibility} = this.props
    const {search} = this.state
    const {results} = search

    const selection = this.getSelectedItems()
    const selectedIds = Set(selection.map(t => t.id))

    batchSetVisibility(selectedIds, privacy).then(() => {
      // I'm just going to update the values in local state until we do the full on reducer thing later
      const newResults = results.map((t) => {
        if (selectedIds.has(t.id)) {
          return t.set('visibility', parseInt(privacy, 10))
        }
        return t
      })
      this.setState({search: Object.assign({}, search, {results: newResults})})

      clearSelection()
    })
  }

  addToCollections = (collectionIds) => {
    const {batchAddCollectionItems} = this.props
    const selectedIds = this.getSelectedItems().map(t => t.id)

    collectionIds.map(cid => {
      batchAddCollectionItems({
        collectionId: cid,
        items: selectedIds.map(id => ({item_type: 'Route', item_id: id}))
      })
    })
  }

  deleteRoutes = () => {
    const {clearSelection, batchDelete} = this.props
    const {search} = this.state
    const {results} = search

    const selectedIds = Set(this.getSelectedItems().map(t => t.id))

    return batchDelete(selectedIds).then(() => {
      const newResults = results.filter((t) => !selectedIds.has(t.id))

      this.setState({search: Object.assign({}, search, {results: newResults}), dialog: null})

      clearSelection()
    })
  }

  toggleArchiveRoutes (archive) {
    const {clearSelection, batchArchive, batchUnarchive} = this.props
    const {search} = this.state
    const {results} = search

    const selectedIds = Set(this.getSelectedItems().map(t => t.id))

    return (archive ? batchArchive : batchUnarchive)(selectedIds).then(() => {
      const newResults = results.filter((t) => !selectedIds.has(t.id))

      this.setState({search: Object.assign({}, search, {results: newResults, results_count: search.results_count - selectedIds.size}), dialog: null})

      clearSelection()
    })
  }

  archiveRoutes = () => {
    return this.toggleArchiveRoutes(true)
  }

  unarchiveRoutes = () => {
    return this.toggleArchiveRoutes(false)
  }

  toggleSort = () => {
    this.setState({showSort: !this.state.showSort})
  }

  loadMore = () => {
    const {loadMoreClicked} = this.state
    this.setState((prevState) => ({
      searchPending: true,
      offset: prevState.offset + prevState.limit,
      limit: MAX_PER_PAGE
    }), () => this._findAsYouType({mergeResults: !!loadMoreClicked}))

    // merge results next time we click loadMore
    this.setState({loadMoreClicked: true})
  }

  showDialog = (dialog) => {
    this.setState({dialog})
  }

  hideDialog = () => {
    this.setState({dialog: null})
  }

  render () {
    const {
      currentUser,
      setPreference,
      selectedItems,
      selectItem,
      deselectItem,
      findRoute
    } = this.props
    const {
      search,
      initialResults,
      searchParams: {
        searchKeywords,
        locationKeywords,
        sortBy,
        sortDir,
        radius,
        filters
      },
      offset,
      limit,
      searchPending,
      selectAllChecked,
      dialog
    } = this.state
    const {results} = search

    if (search === initialResults && results.length === 0 && !search.has_archived) {
      return <EmptyRoutes />
    }

    const showSelects = currentUserHasPrivilege('route_management')
    const showSelectionToolbar = selectedItems.size > 0

    return (
      <Fragment>
        {dialog === DELETE_TROUTES_DIALOG &&
          <DeleteTRoutes
            troutes={this.getSelectedItems()}
            onConfirm={this.deleteRoutes}
            onRequestClose={this.hideDialog} />}
        {dialog === ARCHIVE_ROUTES_DIALOG &&
          <ArchiveRoutes
            routes={this.getSelectedItems()}
            onConfirm={this.archiveRoutes}
            onRequestClose={this.hideDialog} />}
        {dialog === UNARCHIVE_ROUTES_DIALOG &&
          <UnarchiveRoutes
            routes={this.getSelectedItems()}
            onConfirm={this.unarchiveRoutes}
            onRequestClose={this.hideDialog} />}
        <IeNudgeBar currentUser={currentUser} setPreference={setPreference} />
        <ColWrap className={styles.earlyCollapse}>
          <Helmet title='Routes · Ride with GPS' />
          <MainCol>
            <h2 data-heading-alt>Routes</h2>
            <div className={styles.filters}>
              {showSelects && <MobileCollapse><FilterButton>
                <input type='checkbox' onChange={this.toggleSelectAll} checked={selectAllChecked} />
              </FilterButton></MobileCollapse>}
              {showSelectionToolbar && <Fragment>
                <PopoverFilter label='Set Privacy'>
                  {({toggleExpand}) => <Filters.SetPrivacyMenu
                    onApply={(privacy) => { toggleExpand(); this.setPrivacy(privacy) }} />}
                </PopoverFilter>
                {currentUser.accountLevel === 11 && <PopoverFilter label='Add to Collection'>
                  {({toggleExpand}) => <Filters.AddToCollectionMenu
                    userId={currentUser.id}
                    toggleExpand={() => toggleExpand()}
                    troutes={this.getSelectedItems()}
                    objectType='Route'
                    onApply={(collections) => { toggleExpand(); this.addToCollections(collections) }} />}
                </PopoverFilter>}
                {!filters.get('archived') &&
                  <FilterButton onClick={() => this.showDialog(ARCHIVE_ROUTES_DIALOG)} valignCenter>
                    Archive
                  </FilterButton>}
                {filters.get('archived') &&
                  <FilterButton onClick={() => this.showDialog(UNARCHIVE_ROUTES_DIALOG)} valignCenter>
                    Unarchive
                  </FilterButton>}
                <FilterButton onClick={() => this.showDialog(DELETE_TROUTES_DIALOG)} valignCenter>
                  <Icon i='md-trash' style={{color: '#757575'}} size={20} /> Delete
                </FilterButton>
              </Fragment>}
              {!showSelectionToolbar && <Fragment>
                <PopoverFilter label='Distance'>
                  {({toggleExpand}) => <Filters.LengthInput
                    defaultValue={filters.get('length')}
                    onApply={length => { this.setFilter('length', length) }}
                    onClear={() => { toggleExpand(); this.clearFilter('length') }} />}
                </PopoverFilter>
                <PopoverFilter label='Elevation gain'>
                  {({toggleExpand}) => <Filters.ElevationInput
                    defaultValue={filters.get('elevation')}
                    onApply={elevation => { this.setFilter('elevation', elevation) }}
                    onClear={() => { toggleExpand(); this.clearFilter('elevation') }} />}
                </PopoverFilter>
                <PopoverFilter label='Created on'>
                  {({toggleExpand}) => <Filters.DateInput
                    currentUser={currentUser}
                    value={filters.get('createdOn')}
                    defaultValue={filters.get('createdOn')}
                    onApply={createdOn => { this.setFilter('createdOn', createdOn) }}
                    onClear={() => { toggleExpand(); this.clearFilter('createdOn') }} />}
                </PopoverFilter>
                <PopoverFilter label='Updated on'>
                  {({toggleExpand}) => <Filters.DateInput
                    currentUser={currentUser}
                    value={filters.get('updatedOn')}
                    defaultValue={filters.get('updatedOn')}
                    onApply={updatedOn => { this.setFilter('updatedOn', updatedOn) }}
                    onClear={() => { toggleExpand(); this.clearFilter('updatedOn') }} />}
                </PopoverFilter>
                <PopoverFilter label='Options'>
                  {({toggleExpand}) => <Fragment>
                    <Checkbox
                      horizontal
                      onChange={e => this.onHasCuesheetClicked(e)}
                      checked={!!filters.get('hasCuesheet')}
                      label='Has cuesheet' />
                    <Checkbox
                      horizontal
                      className={styles.lastOption}
                      onChange={e => this.onArchivedClicked(e)}
                      checked={!!filters.get('archived')}
                      label='Archived' />
                    <div className={popoverFilterStyles.innerLabel}>Privacy:</div>
                    <Filters.CheckboxInput
                      options={privacyOptions}
                      defaultValue={filters.get('privacy')}
                      onApply={privacy => { this.setFilter('privacy', privacy) }}
                      onClear={() => { toggleExpand(); this.clearFilters(['hasCuesheet', 'archived', 'privacy']) }} />
                  </Fragment>}
                </PopoverFilter>
              </Fragment>}
              <PopoverFilter
                label={`Sort By: ${sortByMenuOpts.get(sortBy)}`}
                hidePopoverLabel
                noPadding
                className={cx(styles.filterRight, styles.specificityHack)}
                icon={<Icon i={`mdi-sort-${sortDir === 'ASC' ? 'ascending' : 'descending'}`} />}>
                <ul className={popoverMenuStyles.PopoverMenu}>
                  <PopoverMenuHeading>Sort Options</PopoverMenuHeading>
                  <PopoverMenuItem>
                    <RadioGroup
                      style={{margin: '0 0'}}
                      horizontal
                      options={sortByMenuOpts}
                      selected={sortBy}
                      radioClass={styles.radioClass}
                      onChange={this.onSortByChange} />
                  </PopoverMenuItem>
                  <PopoverMenuHeading>Sort Order</PopoverMenuHeading>
                  <PopoverMenuItem>
                    <RadioGroup
                      style={{margin: '0 0'}}
                      horizontal
                      options={sortDirMenuOpts}
                      selected={sortDir}
                      radioClass={styles.radioClass}
                      onChange={this.onSortDirChange} />
                  </PopoverMenuItem>
                </ul>
              </PopoverFilter>
            </div>

            <Card noPadding>
              <SearchableCardMulti
                inputs={[
                  <SearchableCardInput
                    key='keyword'
                    placeholder='Keyword'
                    onKeywordChange={this.onSearchKeywordChange}
                    keywords={searchKeywords} />,
                  <UnitAwareSearchableCardLocationInput
                    key='location'
                    placeholder='Start location (city, state)'
                    onKeywordChange={this.onLocationKeywordChange}
                    keywords={locationKeywords}
                    radius={radius}
                    onRadiusChange={this.onRadiusChange} />
                ]}
                resultsLength={results.length}
                resultsCount={!this.isDefaultSearch() ? search.results_count : undefined}
                chips={filters.size > 0 && filters.map((v, k) => <FilterCard key={k} type={k} value={v} onDismiss={() => this.clearFilter(k)} />).valueSeq()}>
                <Results
                  results={results}
                  executeSearch={this.executeSearch}
                  currentUser={currentUser}
                  onResults={this.onResults}
                  showSelects={showSelects}
                  selectedItems={selectedItems}
                  selectItem={selectItem}
                  deselectItem={deselectItem}
                  findRoute={findRoute}
                  accordianProps={{
                    deleteTRoute: this.props.deleteRoute,
                    currentUser: currentUser,
                    pinned: this.props.pinned,
                    pin: this.props.pin,
                    unpin: this.props.unpin
                  }}
                />
                {search.results_count > results.length && search.results_count > limit &&
                <div className={cardStyles.resultsFooter}>
                  <CTA inline secondary margins={false} disabled={searchPending} onClick={() => !searchPending && this.loadMore()}>
                    {searchPending && <CircleSpinner size={14} />} Load more
                  </CTA>
                  <div style={{paddingTop: '20px'}}>
                    <span className={cardStyles.footerText}>Showing 1 - {results.length} of {search.results_count} results</span>
                  </div>
                </div>}
                {!searchPending &&
                  search.results_count > startPageOptions.limit &&
                  (offset + limit) >= search.results_count &&
                  results.length === search.results_count &&
                  <div className={cardStyles.resultsFooter}>
                    <span className={cardStyles.footerText}>No more items to display</span>
                  </div>}
                {results.length === 0 && <IntroWidget large i='md-bicycle'>
                  We couldn't find any routes that matched your search
                </IntroWidget>}
              </SearchableCardMulti>
            </Card>
          </MainCol>
        </ColWrap>
      </Fragment>
    )
  }
}

class Results extends React.Component {
  shouldComponentUpdate (nextProps) {
    return nextProps.results !== this.props.results || nextProps.selectedItems !== this.props.selectedItems
  }

  render () {
    const {
      results,
      executeSearch,
      currentUser,
      onResults,
      showSelects,
      selectedItems,
      selectItem,
      deselectItem,
      accordianProps,
      findRoute
    } = this.props

    const ids = results.map((r) => r.id)

    return (
      <TRouteAccordian {...accordianProps}>
        {ids.map(id => {
          const route = findRoute(id)
          return route && <TRouteListItemExpandable
            condensedComponent={RouteCondensedStats}
            previewComponent={LoadableExpandedRoutePreview}
            key={id}
            troute={route}
            expandKey={id}
            executeSearch={executeSearch}
            currentUser={currentUser}
            onResults={onResults}
            checkbox={showSelects &&
              <RowCheckbox
                onChange={() => selectedItems.has(id)
                  ? deselectItem(id)
                  : selectItem(id)}
                checked={selectedItems.has(id)} />
            } />
        }).filter(x => x)}
      </TRouteAccordian>
    )
  }
}

const UnitAwareSearchableCardLocationInput = withMetricUnits(({metricUnits, ...props}) => (
  <SearchableCardLocationInput
    radiusMenuOpts={metricUnits ? metricRadiusMenuOpts : imperialRadiusMenuOpts}
    {...props} />
))

const FilterCard = withMetricUnits(({type, value, metricUnits, onDismiss}) => {
  const distanceUnits = metricUnits ? 'km' : 'miles'
  const eleUnits = metricUnits ? 'm' : 'ft'

  switch (type) {
    case 'length':
      return <Chip onDismiss={onDismiss}>Distance: {Filters.formatRangeLabel({...value, unitLabel: distanceUnits, metricType: 'distance'})}</Chip>
    case 'elevation':
      return <Chip onDismiss={onDismiss}>Elevation: {Filters.formatRangeLabel({...value, unitLabel: eleUnits, metricType: 'distance'})}</Chip>
    case 'privacy':
      return <Chip onDismiss={onDismiss}>Privacy: {Filters.formatCheckboxLabel(value, privacyOptions)}</Chip>
    case 'createdOn':
      return <Chip onDismiss={onDismiss}>Created: {Filters.formatDateRangeLabel(value.min, value.max)}</Chip>
    case 'updatedOn':
      return <Chip onDismiss={onDismiss}>Updated: {Filters.formatDateRangeLabel(value.min, value.max)}</Chip>
    case 'hasCuesheet':
      return <Chip onDismiss={onDismiss}>Has cuesheet</Chip>
    case 'archived':
      return <Chip onDismiss={onDismiss}>Archived</Chip>
    default:
      console.warn(`encountered unknown filter type ${type}`)
      return null
  }
})

const doInitialSearch = (currentUser) => (
  apiv3.routes.search({
    limit: DEFAULT_PER_PAGE,
    userId: currentUser.id,
    sortBy: 'departed_or_created DESC'
  })
)

export const Routes = withSelect(_Routes)

const LoadableRoutes = (props) => {
  return <Loadable
    {...props}
    component={Routes}
    loadingText='Loading your routes'
    resourceLoaded={() => {
      props.loadCollections(props.currentUser.id)
      return doInitialSearch(props.currentUser)
        .then((resp) => {
          props.spoofRoutes(resp.rawResults)
          return resp
        })
    }} />
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.currentUser,
    pinned: (id) => !!state.favorites.getIn(['favoritesByType', 'route', id]),
    findRoute: (id) => {
      return routeResourceSelectors.find(state, id)
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  const actionCreators = {
    deleteRoute: routesActions.deleteRoute,
    batchSetVisibility: routesActions.batchSetVisibility,
    batchDelete: routesActions.batchDelete,
    batchArchive: routesActions.batchArchive,
    batchUnarchive: routesActions.batchUnarchive,
    pin: favoritesActions.pin,
    unpin: favoritesActions.unpin,
    setPreference: userActions.setPreference,
    loadCollections: collectionActions.list,
    batchAddCollectionItems: collectionItemActions.batchAdd
  }

  return {
    ...bindActionCreators(actionCreators, dispatch),
    spoofRoutes: (extras) => dispatch(spoofV3ResourceExtras(extras, [Route]))
  }
}

export const RoutesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableRoutes)
